const DEM_KEYWORDS = [
  // Platforms & committees
  'ACTBLUE', 'DEMOCRAT', 'DEMOCRATIC', 'DNC', 'DCCC', 'DSCC',
  // Super PACs
  'SENATE MAJORITY PAC', 'SMP', 'HOUSE MAJORITY PAC', 'HMP',
  'PRIORITIES USA', 'MAJORITY FORWARD', 'FUTURE FORWARD',
  'AB PAC', 'TAKE BACK THE HOUSE', 'LINCOLN PROJECT',
  // Presidents & VP
  'BIDEN', 'HARRIS', 'OBAMA', 'CLINTON',
  // Leaders
  'PELOSI', 'SCHUMER', 'JEFFRIES',
  // Major candidates
  'ALLRED', 'CASAR', 'BETO', "O'ROURKE",
  'WARNOCK', 'OSSOFF', 'MARK KELLY', 'KELLY FOR SENATE',
  'SHERROD BROWN', 'FRIENDS OF SHERROD', 'TESTER', 'MONTANANS FOR TESTER',
  'ROSEN FOR NEVADA', 'JACKY ROSEN',
  'CORY BOOKER', 'BOOKER FOR SENATE',
  'SCHIFF FOR', 'ADAM SCHIFF',
  'WILL ROLLINS', 'ROLLINS FOR CONGRESS',
  'KATIE PORTER', 'PORTER FOR',
  'FETTERMAN', 'TAMMY BALDWIN', 'BALDWIN FOR',
  'BOB CASEY', 'CASEY FOR', 'GALLEGO', 'SLOTKIN', 'MUCARSEL',
  'COLIN ALLRED FOR',
  // Issue / advocacy
  'PROGRESSIVE', 'INDIVISIBLE', 'MOVEON',
  "EMILY'S LIST", 'EMILYS LIST', 'PLANNED PARENTHOOD', 'EVERYTOWN',
  'SIERRA CLUB', 'LEAGUE OF CONSERVATION', 'END CITIZENS', 'ACLU',
  'STOP REPUBLICANS', 'PROGRESSIVE TURNOUT', 'SWING LEFT', 'FAIR FIGHT',
  'DEMAND JUSTICE', 'VOTE VETS', 'VOTEVETS', 'FOR OUR FUTURE', 'BLUE PAC',
];

const REP_KEYWORDS = [
  // Platforms & committees
  'WINRED', 'REPUBLICAN', 'GOP', 'RNC', 'NRCC', 'NRSC',
  // Super PACs & leadership PACs
  'CONGRESSIONAL LEADERSHIP FUND', 'SENATE LEADERSHIP FUND',
  'CLUB FOR GROWTH', 'MADISON PROJECT', 'SEAL PAC',
  'GROW THE MAJORITY', 'PROTECT THE HOUSE',
  'RJC', 'REPUBLICAN JEWISH',
  'SFA FUND', 'STAND FOR AMERICA',
  'SAVING ARIZONA', 'PROTECT OHIO VALUES',
  // Trump & MAGA
  'TRUMP', 'MAKE AMERICA GREAT', 'MAGA', 'SAVE AMERICA', 'NEVER SURRENDER',
  // Presidents & VP
  'PENCE', 'DESANTIS',
  // Leaders
  'MCCONNELL', 'SCALISE',
  // Major candidates
  'CRUZ', 'TED CRUZ', 'TEXANS FOR TED',
  'ABBOTT', 'CORNYN', 'RAND PAUL',
  'JD VANCE', 'VANCE FOR',
  'LOEFFLER', 'PERDUE', 'HERSCHEL WALKER',
  'NIKKI HALEY', 'HALEY FOR PRESIDENT',
  'VAN DUYNE', 'BETH VAN DUYNE', 'BETH VICTORY',
  'EMMER', 'TOM EMMER',
  'MARCO RUBIO', 'RUBIO FOR',
  'RICK SCOTT', 'TIM SCOTT', 'LARRY ELDER', 'VIVEK',
  // Issue / advocacy
  'NRA', 'NATIONAL RIFLE', 'PATRIOT', 'CONSERVATIVE',
  'HERITAGE', 'FREEDOM CAUCUS', 'TEA PARTY',
  'AMERICA FIRST', 'CPAC', 'CITIZENS UNITED', 'JUDICIAL WATCH',
];

const getPartyColor = (name) => {
  if (!name) return null;
  const upper = name.toUpperCase();
  const isDem = DEM_KEYWORDS.some(kw => upper.includes(kw));
  const isRep = REP_KEYWORDS.some(kw => upper.includes(kw));
  if (isDem && !isRep) return 'democrat';
  if (isRep && !isDem) return 'republican';
  if (isDem && isRep) return 'mixed';
  return null;
};

const getPartyTextClass = (name) => {
  const party = getPartyColor(name);
  if (party === 'democrat') return 'text-blue-600';
  if (party === 'republican') return 'text-red-600';
  if (party === 'mixed') return 'text-purple-600';
  return '';
};

const getPieColor = (name, index, defaultColors) => {
  const party = getPartyColor(name);
  if (party === 'democrat') return '#2563eb';
  if (party === 'republican') return '#dc2626';
  if (party === 'mixed') return '#7c3aed';
  return defaultColors[index % defaultColors.length];
};

const COLORS = ['#0f172a', '#334155', '#64748b', '#94a3b8', '#cbd5e1', '#e2e8f0', '#f1f5f9', '#10b981'];

const PARTY_COLORS = {
  democrat: ['#1e40af', '#2563eb', '#3b82f6', '#60a5fa', '#93c5fd', '#bfdbfe', '#dbeafe', '#1d4ed8'],
  republican: ['#991b1b', '#dc2626', '#ef4444', '#f87171', '#fca5a5', '#fecaca', '#fee2e2', '#b91c1c'],
  mixed: ['#5b21b6', '#7c3aed', '#8b5cf6', '#a78bfa', '#c4b5fd', '#ddd6fe', '#ede9fe', '#6d28d9'],
};

const PARTY_THEME = {
  democrat: { bg: 'bg-blue-600', bgLight: 'bg-blue-50', border: 'border-blue-200', text: 'text-blue-700', gradient: 'from-blue-50 to-white', accent: '#2563eb', label: 'Democratic Donor' },
  republican: { bg: 'bg-red-600', bgLight: 'bg-red-50', border: 'border-red-200', text: 'text-red-700', gradient: 'from-red-50 to-white', accent: '#dc2626', label: 'Republican Donor' },
  mixed: { bg: 'bg-purple-600', bgLight: 'bg-purple-50', border: 'border-purple-200', text: 'text-purple-700', gradient: 'from-purple-50 to-white', accent: '#7c3aed', label: 'Bipartisan Donor' },
};

const formatCurrency = (value) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 }).format(value);

const formatCurrencyShort = (value) => {
  if (value >= 1000000) return `$${(value / 1000000).toFixed(1)}M`;
  if (value >= 1000) return `$${(value / 1000).toFixed(1)}K`;
  return `$${value.toFixed(0)}`;
};

export {
  getPartyColor,
  getPartyTextClass,
  getPieColor,
  COLORS,
  PARTY_COLORS,
  PARTY_THEME,
  formatCurrency,
  formatCurrencyShort,
};
